<!--
 * @description: 首页图片
 * @param: 
 * @return: 
-->
<template>
  <div class="echarts-header">
    <div class="echarts-header-left">
      <div class="echarts-header-title" :style="titleBg">我的待办</div>
      <div class="echarts-header-left-centent">
        <div
          class="header-list clickBacklog"
          v-for="(item, index) in list"
          :key="item.id"
          :style="{ 'background-color': `rgb(${item.color})` }"
          @click="handleClick(item)"
        >
          <div class="img-container">
            <!-- :style="{ 'background-color': `rgb(${item.imgBgcolor})` }" -->
            <div
              :style="{
                'background-image':
                  'url(' +
                  require(`../../assets/images/icon/${item.backgroundImage}.png`) +
                  ')',
              }"
              class="img-container-bg"
            ></div>
          </div>
          <div class="text-container">
            <div class="bottom">
              <span class="large">{{ item.total }}</span>
              <span class="large">条 </span>
            </div>

            <div class="top">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="echarts-header-right">
      <div class="echarts-header-title" :style="titleBg">最新消息</div>
      <div class="info-box">
        <div class="header-list">
          <div class="img-container">
            <div
              class="img-container-bg"
              :style="{
                'background-image':
                  'url(' +
                  require(`../../assets/images/icon/icon_title.png`) +
                  ')',
              }"
            >
              <!-- <img src="../../assets/images/icon/icon_title.png" alt="" srcset=""> -->
            </div>
          </div>
          <div class="text-container">
            <div class="bottom">
              <span class="large">{{ inforTotal }}</span>
              <span class="large">条</span>
            </div>

            <div class="top">新消息通知</div>
          </div>
        </div>
        <div class="new-info-box">
          <el-carousel
            height="100px"
            direction="vertical"
            :autoplay="true"
            interval="6000"
            style="background: #ffffff"
          >
            <el-carousel-item v-for="item in inforList" :key="item">
              <div
                class="content-list"
                :class="{ 'content-list-new': i.IsReadLine == 0 }"
                v-for="(i, index) in item.item"
                :key="i.Id"
              >
                <div class="info-list" @click="infoClick(i)">
                  <span>{{ i.AddDate }}</span>
                  <span :class="i.IsReadLine == 0 ? 'new' : 'old'">{{
                    i.Title
                  }}</span>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

    <el-dialog
      v-model="dialogVisible"
      center
      custom-class="cover-dialog"
      :show-close="true"
      title=""
    >
      <!-- <div style="width: 86%;min-height: 258px; margin: 50px auto 0 auto; padding:0;">
        {{ inforConcat }}
      </div> -->
      <div
        style="
          width: 100%;
          height: 230px;
          margin: 50px auto 0 auto;
          padding: 0 40px;
          overflow: auto;
          line-height: 28px;
          font-size: 20px;
          padding-bottom: 31px;
        "
      >
        <div v-html="inforConcat"></div>
        <!-- {{ inforConcat }} -->
      </div>

      <template #footer>
        <span class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
          <el-button type="primary" @click="dialogVisible = false"
            >知道了</el-button
          >
          <el-button type="warning" @click="infoNowShow">不再提醒</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="dialogVisibleImg"
      center
      :show-close="false"
      width="80%"
      hidden="80%"
      top="10vh"
      title=""
      custom-class="dialogIMG-bg"
    >
      <!-- <div style="">1231</div> -->
      <div
        style="
          margin: 0 auto 10px auto;
          text-align: center;
          width: 100%;
          height: 70vh;
        "
      >
        <img
          style="height: 70vh; margin: 0 auto"
          :src="inforIMG"
          alt=""
          srcset=""
        />
      </div>
      <div style="text-align: center">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisibleImg = false"
            >知道了</el-button
          >
          <el-button type="warning" @click="infoNowShow">不再提醒</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
  <!-- <div style="widht:50%; background:gray;">123456</div> -->
</template>

<script>
import panelContainer from "@/components/panelContainer.vue";
import field from "@/components/textField.vue";
import searchButton from "@/components/searchButton.vue";
import cardPanel from "@/components/cardPanel.vue";
import chart from "@/components/vChart.vue";
import tabelApi from "@/api/tabel.js";
import { errMsg } from "@/notify/index.js";
import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  onMounted,
  onUnmounted,
  getCurrentInstance,
  watch,
} from "vue";
import { useRouter } from "vue-router";
import store from "@/store/index.js";
export default defineComponent({
  name: "ChartReports",
  components: {
    // chart,
  },
  props: {
    titleBg: Object,
  },
  setup() {
    // const ws = new WebSocket(`ws://192.168.1.20:8007/ws`);
    let router = useRouter();
    let sessionToKen = store.getters.getWsUserId;
    // ws.onopen = function(event) {
    //   console.log('open---',event)
    // }
    // console.log('proy--', proxy)

    let data = reactive({
      list: [
        {
          color: "54,202,187",
          imgBgcolor: "132,223,214",
          title: "待寄出设备",
          total: 12363,
          backgroundImage: "icon_待寄出",
        },
        {
          color: "210,88,88",
          imgBgcolor: "228,155,155",
          title: "维修中设备",
          total: 5,
          backgroundImage: "icon_维修中设备",
        },
        {
          color: "18,171,104",
          imgBgcolor: "113,205,164",
          title: "待维护设备",
          total: 5,
          backgroundImage: "icon_待维护设备",
        },
        {
          color: "128,95,194",
          imgBgcolor: "179,159,218",
          title: "返回待确认",
          total: 5,
          backgroundImage: "icon_返回待确认",
        },
      ],
      infoData: [],
      dialogVisible: false,
      inforConcat: "",
      inforID: "",
      dialogVisibleImg: false,
      inforIMG: "",
    });

    // watch(()=>{
    //     return data.router
    // }, (newVaule)=>{
    //   console.log("watch--", newVaule)
    // })

    onMounted(() => {
      let wsUserId = store.getters.getWsUserId;
      console.log("wsUserId--", wsUserId);
      // methods.initInfo(wsUserId)
      // 第一版 传id
      // methods.newInitInfo(wsUserId)
      const senndInfo = JSON.stringify({
        MessageType: 1,
        UserId: wsUserId,
      });
      // 第二版传类型
      methods.newInitInfo(senndInfo);

      methods.getSourceData();
    });

    onUnmounted(() => {
      // const wss = proxy.$websocket;
      // console.log("websocket 已关闭 ...");
      // ws.close();
    });

    // 使用计算属性
    let inforList = computed(() => {
      return data.infoData;
    });

    let inforTotal = computed(() => {
      let index = 0;
      const arr = data.infoData;
      arr.forEach((o) => {
        o.item.forEach((i) => {
          if (!i.IsReadLine) {
            index++;
          }
        });
      });
      return index;
    });

    let methods = {
      // 最新消息强制弹出
      newestInfo(param) {
        console.log("最新消息强制弹出", param);
        // 消息创建时间 （一天的时间86400000）
        let createdData = new Date(param.OrderDate);
        let createdTime = new Date(createdData).getTime() + 3 * 86400000;

        // 获取当前时间
        let nowData = new Date();
        let nowTime = new Date(nowData).getTime();

        // 结束时间
        // let endTime = new Date('2021.10.03 00:00:00').getTime()
        let endTime = new Date("2022.10.03 00:00:00").getTime();
        if (nowTime > createdTime) {
          console.log("超时信息 ");
          return;
        }

        // if (param.IsReadLine == 0) {
        //    methods.infoClick(param)
        // }
        if (!param.NotRemind) {
          methods.infoClick(param);
        }
      },
      //
      newInitInfo(id) {
        const { proxy } = getCurrentInstance();
        proxy.$resetWebsocket();
        const ws = proxy.$websocket();
        console.log("webSocket", ws);
        // 2. ws.send()给服务器发送信息
        ws.onopen = function (evt) {
          console.log("Connection open ...");
          ws.send(id);
        };
        // 3.服务器每次返回信息都会执行一次onmessage方法
        ws.onmessage = function (evt) {
          const res = JSON.parse(evt.data);
          let infoListData = null;
          if (res.MessageType == 1) {
            infoListData = JSON.parse(res.Message);
          }
          console.log("服务器返回的信息: " + infoListData);
          console.log(
            "服务器返回的信息:",
            JSON.stringify(infoListData, null, 2)
          ); // 格式化输出
          if (infoListData == null) {
            return console.log("没有信息");
          }
          methods.newestInfo(infoListData[0]);
          const infoArr = [
            { item: [...infoListData.slice(0, 4)], id: 1 },
            { item: [...infoListData.slice(4, 8)], id: 2 },
            { item: [...infoListData.slice(8, 12)], id: 3 },
          ];
          data.infoData = infoArr.filter((i) => i.item.length);
        };
      },
      handleClick(item) {
        let itemObj = {
          icon: "el-icon-s-management",
          path: "/home/CusRepairTransfer",
          text: "运送到维修中心",
          closable: true,
        };
        let tabsArray = store.getters.getTabs;
        switch (item.title) {
          case "待寄出设备":
            itemObj.path = "/home/CusRepairTransfer";
            itemObj.text = "运送到维修中心";
            break;
          case "维修中设备":
            itemObj.path = "/home/CusRepairList";
            itemObj.text = "申请列表";
            break;
          case "返回待确认":
            itemObj.path = "/home/repairRecieve";
            itemObj.text = "已维修设备接收";
            // errMsg('新的模块开发中')
            break;
          case "待维护设备":
            itemObj.path = "/home/management";
            itemObj.text = "设备维护";
            break;
        }

        tabsArray.some((s) => s.path == itemObj.path) ||
          tabsArray.push(itemObj);
        sessionStorage.setItem("set_tabs", JSON.stringify(tabsArray));
        store.dispatch("set_tabs", tabsArray);
        store.dispatch("set_selectedTab", itemObj.path);
        router.push({
          path: itemObj.path,
        });
      },
      getSourceData() {
        const arr = [
          "DaiYouCount",
          "ApplicationCount",
          "MaintainCount",
          "ReturnConCount",
        ];
        arr.forEach((item, index) => {
          tabelApi.FirstPagePhoto({}, item).then((res) => {
            const { data: obj } = res;
            data.list[index].total = obj[item];
          });
        });
      },
      infoClick(i) {
        data.UserId++;
        if (i.Terminal == null) {
          //普通消息
          data.dialogVisible = true;
        } else {
          //图片消息
          data.dialogVisibleImg = true;
        }
        data.inforConcat = i.StyleText;
        data.inforIMG = i.Terminal;
        data.inforID = i.Id;
        tabelApi.MessageReadLine({ Id: i.Id });
        i.IsReadLine = 1;
      },
      // 不在提示
      infoNowShow() {
        let wsUserId = store.getters.getWsUserId;
        let nowInfo = JSON.stringify({
          MessageType: 2,
          UserId: wsUserId,
          MessageId: data.inforID,
        });
        console.log("不在提示--", nowInfo);
        // methods.newInitInfo(nowInfo)
        ws.send(nowInfo);
        //关闭公告win
        if (data.inforIMG == null) {
          //普通消息
          data.dialogVisible = false;
        } else {
          //图片消息
          data.dialogVisibleImg = false;
        }
      },
    };

    return {
      inforTotal,
      inforList,
      ...toRefs(data),
      ...methods,
    };
  },
});
</script>

<style lang="scss" scoped>
.echarts-header {
  width: 100%;
  // height: 100%;
  display: flex;
  // margin-top:10px;
  margin-bottom: 10px;
  justify-content: space-between;

  .echarts-header-left,
  .echarts-header-right {
    width: 49.8%;
    border: 1px solid #cccccc;
    border-radius: 6px;
    // padding: 8px;
  }

  .echarts-header-title {
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    border-bottom: 1px solid #e9e9e9;
  }

  .echarts-header-left-centent {
    display: flex;
    justify-content: space-evenly;
  }

  .info-box {
    display: flex;
    padding-left: 8px;
    justify-content: space-between;

    .new-info-box {
      width: 580px;

      .content-list {
        padding-left: 25px;
      }
      .content-list-new {
        background: url(../../assets/images/icon/icon_info.png) no-repeat 0 80%;
      }
    }
    .info-list {
      width: 96%;
      height: 30px;
      display: flex;
      padding-left: 10px;
      overflow: hidden;
      border-bottom: 1px solid #e8e8e8;

      span {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
      }
      span.new,
      span.old {
        width: 400px;
        padding-left: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span.new {
        font-weight: bold;
      }
    }
  }

  .header-list {
    margin-top: 0.041667rem;
    box-shadow: 0.010417rem 0.010417rem 0.026042rem #888888;
    width: 0.989583rem;
    height: 0.572917rem;
    background-color: #36cabb;
    padding-right: 22px;
    display: flex;
    border-radius: 0.015625rem;
    justify-content: space-between;
    align-items: flex-start;
    .img-container {
      width: 40px;
      height: 40px;
      text-align: center;
      margin: 20px 0 0 20px;
      border-radius: 50%;
      // background-color: rgb(132, 223, 214);
      color: white;
      display: flex;
      .img-container-bg {
        width: 65%;
        height: 65%;
        background-size: contain;
        background-repeat: no-repeat;
        margin: auto;
      }
    }
    .text-container {
      color: white;
      display: flex;
      font-size: 18px;
      flex-direction: column;
      align-items: end;
      .bottom {
        font-size: 30px;
        font-weight: 400;
        margin-top: 26px;
        margin-bottom: 8px;
        .large {
          font-size: 24px;
        }
      }
    }
  }
  .header-list:hover {
    .img-container-bg {
      width: 100%;
      height: 100%;
    }
  }
  .clickBacklog {
    cursor: pointer;
  }
}
:deep(.el-carousel__indicator--vertical .el-carousel__button) {
  background-color: rgb(39, 114, 65);
}
:deep .cover-dialog {
  // width: 902px;
  // height: 502px;
  overflow: hidden;
  border-radius: 10px !important;
  background: url(../../assets/images/contract/infoBg.png) no-repeat 100% 100%;
  background-size: 100% 100%;
  .dialog-footer {
    text-align: center;
  }
}
:deep .el-overlay .dialogIMG-bg {
  background: none;
  box-shadow: 0 0 0 #888888;
  -webkit-box-shadow: 0 0 0 #888888;
}
</style>
